import { useState, useEffect, createContext, useContext } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState('de');

  useEffect(() => {
    const stored = localStorage.getItem('baselmitkindern_language');
    if (stored) {
      setLanguageState(stored);
    }
  }, []);

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('baselmitkindern_language', lang);
  };

  const t = (de, en) => {
    return language === 'en' ? (en || de) : de;
  };

  const getField = (obj, fieldBase) => {
    if (!obj) return '';
    const enField = `${fieldBase}_en`;
    const deField = `${fieldBase}_de`;
    if (language === 'en' && obj[enField]) {
      return obj[enField];
    }
    return obj[deField] || obj[fieldBase] || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getField }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: 'de',
      setLanguage: () => {},
      t: (de) => de,
      getField: (obj, field) => obj?.[`${field}_de`] || obj?.[field] || ''
    };
  }
  return context;
}

export default useLanguage;